function alertParameterPricePlanTypeCategoryController(alertsFrameworkService, pricePlanService) {
	const $ctrl = this;

	$ctrl.arePricePlanTypeCategoriesLoading = false;

	$ctrl.$onInit = function () {
		loadPricePlanTypeCategories();

		$ctrl.pricePlanTypeCategoryKeys = alertsFrameworkService.getKeyArrayFromCsv($ctrl.model);
	};

	/* Handle Model Changes on the Parent */
	$ctrl.$onChanges = function(changes) {
		if (changes.model){
			const newKeys = alertsFrameworkService.getKeyArrayFromCsv(changes.model.currentValue);
			const arraysEqual = 
				newKeys.length === $ctrl.pricePlanTypeCategoryKeys.length 
				&& newKeys.every((value, index) => value === $ctrl.pricePlanTypeCategoryKeys[index]);

			if (!arraysEqual)
			{
				$ctrl.pricePlanTypeCategoryKeys = newKeys;
			}        
		}		
    }
   

	$ctrl.pricePlanTypeCategoriesChanged = (item, model) => {
		const csvValue = alertsFrameworkService.getCsvFromKeyArray($ctrl.pricePlanTypeCategoryKeys);
		
		$ctrl.onUpdate({csvValue: csvValue});
	};
		

	function loadPricePlanTypeCategories() {
		$ctrl.arePricePlanTypeCategoriesLoading = true;

		return pricePlanService
			.getPricePlanTypeCategories($ctrl.subscriberKey)
			.then((pricePlanTypeCategories) => {
				$ctrl.pricePlanTypeCategories = pricePlanTypeCategories.toSorted((a, b) => {
                    const nameA = a.pricePlanTypeCategoryName.toUpperCase();
                    const nameB = b.pricePlanTypeCategoryName.toUpperCase();

                    if (nameA < nameB) {
                        return -1;
                    }

                    if (nameA > nameB) {
                        return 1;
                    }

                    return 0;
                });
                
				$ctrl.arePricePlanTypeCategoriesLoading = false;
			});
	}
}

angular
	.module("angus.components")
	.component("alertParameterPricePlanTypeCategory", {
		controller: alertParameterPricePlanTypeCategoryController,
		bindings: {
			subscriberKey: "<",
			label: "<",
			model: "<",
			isReadOnly: "<",
			onUpdate: "&"
		},
		template: `
<label class="control-label" for="pricePlanTypeCategories">{{$ctrl.label || 'Price Plan'}}
    <i class="fa fa-spinner fa-spin" data-fade-toggle="arePricePlanTypeCategoriesLoading"></i></label>

<ui-select
    class="alert-select" 
	multiple 
	ng-model="$ctrl.pricePlanTypeCategoryKeys" 
	ng-disabled="!$ctrl.pricePlanTypeCategories.length || $ctrl.isReadOnly" 
	on-select="$ctrl.pricePlanTypeCategoriesChanged($item, $model)" 
	on-remove="$ctrl.pricePlanTypeCategoriesChanged($item, $model)"
>
    <ui-select-match placeholder="Select price plans...">{{$item.pricePlanTypeCategoryName}}</ui-select-match>
    <ui-select-choices repeat="pricePlanTypeCategory.pricePlanTypeCategoryKey as pricePlanTypeCategory in $ctrl.pricePlanTypeCategories | filter: {pricePlanTypeCategoryName: $select.search}">
        {{pricePlanTypeCategory.pricePlanTypeCategoryName}}</ui-select-choices>
</ui-select>
		`
	});
